/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMaximizeAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 9h-2l-.001-3.607L17 8.353v7.233l3 3V15h2v7h-7v-2h3.585l-3-3h-7.23l-2.961 3H9v2H2v-7h2l.001 3.564L7 15.524v-7.11L4.035 5.45V9l-2 .001V2.035H9v2l-3.55.001L8.414 7h7.11l3.037-3H15V2h7v7zM9 15h6V9H9v6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMaximizeAlt as MaximizeAlt };
